/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Cv_Review_Category_FormattingInputs */

const en_cv_review_category_formatting = /** @type {(inputs: Cv_Review_Category_FormattingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Formatting & Layout`)
};

const de_cv_review_category_formatting = /** @type {(inputs: Cv_Review_Category_FormattingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Formatierung & Layout`)
};

/**
* | output |
* | --- |
* | "Formatting & Layout" |
*
* @param {Cv_Review_Category_FormattingInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const cv_review_category_formatting = /** @type {((inputs?: Cv_Review_Category_FormattingInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cv_Review_Category_FormattingInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_cv_review_category_formatting(inputs)
	return en_cv_review_category_formatting(inputs)
});